import * as React from "react";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { actionProgressStore } from "./ActionProgressStore";
import { Progress, Button, Row, Col, Spin, Space } from "antd";
import { notificationInstance } from "App";

interface ActionProgressProps extends WithTranslation {}

export const ActionProgress = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ActionProgressProps> {
      private interval: NodeJS.Timeout;
      componentDidMount(): void {
        this.interval = setInterval(this.setProgressObserver, 100);
      }
      componentWillUnmount(): void {
        clearInterval(this.interval);
      }
      setProgressObserver = () => {
        const { t } = this.props;
        // to update progress of pending notifications
        actionProgressStore.progressMap.forEach(({ percent, initialMessage }, uid) => {
          // to show notification only for started downloads
          // if (percent > 0) {
          notificationInstance.open({
            placement: "bottomRight",
            duration: null,
            key: uid,
            title: t("Downloading") + "...",
            description: (
              <Row>
                <Col span={18}>
                  {!percent && initialMessage ? (
                    <Space orientation="horizontal">
                      <Spin size="small" />
                      {initialMessage}
                    </Space>
                  ) : (
                    <Progress status="active" percent={percent} size="small" />
                  )}
                </Col>
                <Col span={6} className="text-right">
                  <Button size="small" type="default" onClick={() => actionProgressStore.dismiss(uid)}>
                    {t("Cancel")}
                  </Button>
                </Col>
              </Row>
            ),
            onClose: () => actionProgressStore.dismiss(uid),
          });
          // }
        });
        // to dismiss finished notifications
        actionProgressStore.notificationsToClose.forEach((key) => {
          notificationInstance.destroy(key);
          actionProgressStore.removeNotificationKey(key);
        });
      };

      render() {
        return null;
      }
    }
  )
);
